import React from "react";
import { BUY_LINKS, COUNTRIES } from "../../data/content";

export default function BookBuyLink({ book, country, status }) {
  const url = country ? BUY_LINKS[book.id]?.[country] : null;
  const store = COUNTRIES.find((item) => item.code === country)?.store;

  if (!url) {
    const label = status === "loading" ? "Finding your store…" : "Choose country above";
    return (
      <span
        className="btn-buy cursor-not-allowed opacity-55"
        aria-live="polite"
        data-testid={`buy-now-unavailable-${book.id}`}
      >
        {label}
      </span>
    );
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="btn-buy"
      aria-label={`Buy ${book.title} on ${store}`}
      data-testid={`buy-now-${book.id}`}
    >
      Buy on {store}
      <span aria-hidden="true">↗</span>
    </a>
  );
}